(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collector-email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-collector-signup')) {
    customElements.define('product-collector-signup', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.success = this.querySelector('.mwc-product-collector__success');
        this.status = this.querySelector('.mwc-product-collector__status');
        this.codeButton = this.querySelector('.mwc-product-collector__code');
        this.joinedKey = 'mwc_collector_joined';

        if (localStorage.getItem(this.joinedKey) === 'true') this.revealCode();
        this.form?.addEventListener('submit', (event) => this.submit(event));
        this.codeButton?.addEventListener('click', () => this.copyCode());
      }

      revealCode() {
        if (this.form) this.form.hidden = true;
        if (this.success) this.success.hidden = false;
      }

      async submit(event) {
        event.preventDefault();
        const button = this.form?.querySelector('button[type="submit"]');
        if (!this.form || !button) return;
        button.disabled = true;
        this.status.hidden = true;

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Subscription failed');
          localStorage.setItem(this.joinedKey, 'true');
          this.revealCode();
          this.success?.focus();
        } catch (error) {
          this.status.textContent = this.dataset.errorMessage;
          this.status.hidden = false;
          button.disabled = false;
        }
      }

      async copyCode() {
        const code = this.codeButton?.dataset.code;
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          const label = this.codeButton.querySelector('small');
          if (label) label.textContent = this.dataset.copiedLabel;
        } catch (error) {
          const label = this.codeButton.querySelector('small');
          if (label) label.textContent = code;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scale-studio"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scale-studio')) {
    customElements.define('scale-studio', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.mwc-scale-dialog');
        this.trigger = this.querySelector('.mwc-scale-trigger');
        this.referenceSelect = this.querySelector('.mwc-scale-reference');
        this.stage = this.querySelector('.mwc-scale-stage');
        this.art = this.querySelector('.mwc-scale-art');
        this.referenceObject = this.querySelector('.mwc-scale-reference-object');
        this.referenceSvg = this.querySelector('.mwc-scale-reference-svg');
        this.sizeReadout = this.querySelector('.mwc-scale-size');
        this.referenceReadout = this.querySelector('.mwc-scale-reference-label');
        this.variants = JSON.parse(this.querySelector('.mwc-scale-variants')?.textContent || '[]');
        this.unit = 'in';
        this.referenceSelect.value = this.dataset.defaultReference || 'tv';
        this.trigger?.addEventListener('click', () => {
          this.update();
          this.dialog?.showModal();
        });
        this.referenceSelect?.addEventListener('change', () => this.update());
        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.addEventListener('click', () => {
            this.unit = button.dataset.unit;
            this.querySelectorAll('[data-unit]').forEach((item) => {
              const active = item === button;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', String(active));
            });
            this.update();
          });
        });
        this.productArea = this.closest('.shopify-section') || document;
        this.productArea.addEventListener('change', this.handleVariantChange = () => setTimeout(() => this.update(), 40));
        window.addEventListener('resize', this.handleResize = () => {
          if (this.dialog?.open) this.update();
        });
      }

      disconnectedCallback() {
        this.productArea?.removeEventListener('change', this.handleVariantChange);
        window.removeEventListener('resize', this.handleResize);
      }

      currentVariant() {
        const inputs = this.productArea?.querySelectorAll('form[action*="/cart/add"] [name="id"]') || [];
        for (const input of inputs) {
          const match = this.variants.find((variant) => String(variant.id) === String(input.value));
          if (match) return match;
        }
        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        return this.variants.find((variant) => String(variant.id) === String(urlVariant)) || this.variants.find((variant) => String(variant.id) === String(this.dataset.initialVariant)) || this.variants[0];
      }

      parseDimensions(variant) {
        if (!variant) return null;
        const text = [...(variant.options || []), variant.title || ''].join(' | ').replace(/[\u200e\u200f\u2066-\u2069]/g, '').replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).replace(/سم/g, 'cm').replace(/بوصة/g, 'in');
        const inchMatches = [...text.matchAll(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ches)?\b)/gi)];
        if (inchMatches.length) {
          const match = inchMatches[inchMatches.length - 1];
          return { width: Number(match[1]), height: Number(match[2]) };
        }
        const cmMatch = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\b/i);
        if (cmMatch) return { width: Number(cmMatch[1]) / 2.54, height: Number(cmMatch[2]) / 2.54 };
        const plainMatch = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if (plainMatch) return { width: Number(plainMatch[1]), height: Number(plainMatch[2]) };
        return null;
      }

      references() {
        return {
          tv: { width: 61, height: 34.3, layout: 'side', label: this.referenceSelect.options[0].text },
          sofa: { width: 84, height: 34, layout: 'above', label: this.referenceSelect.options[1].text },
          queen: { width: 60, height: 48, layout: 'above', label: this.referenceSelect.options[2].text },
          king: { width: 76, height: 48, layout: 'above', label: this.referenceSelect.options[3].text },
          desk: { width: 60, height: 30, layout: 'above', label: this.referenceSelect.options[4].text },
          person: { width: 22, height: 70, layout: 'side', label: this.referenceSelect.options[5].text }
        };
      }

      referenceMarkup(type) {
        const markup = {
          tv: '<rect class="mwc-ref-main" x="4" y="4" width="92" height="82" rx="2"/><path class="mwc-ref-detail" d="M37 92H63M50 86V92"/>',
          sofa: '<path class="mwc-ref-main" d="M7 45Q7 34 18 34H82Q93 34 93 45V84H7Z"/><path class="mwc-ref-detail" d="M7 62H93M20 34V62M80 34V62M14 84V96M86 84V96"/>',
          queen: '<path class="mwc-ref-main" d="M5 25H95V88H5Z"/><path class="mwc-ref-detail" d="M5 55H95M12 88V97M88 88V97"/>',
          king: '<path class="mwc-ref-main" d="M5 25H95V88H5Z"/><path class="mwc-ref-detail" d="M5 55H95M12 88V97M88 88V97"/>',
          desk: '<path class="mwc-ref-main" d="M5 28H95V48H5Z"/><path class="mwc-ref-detail" d="M14 48V96M86 48V96M31 62H69"/>',
          person: '<circle class="mwc-ref-main" cx="50" cy="14" r="11"/><path class="mwc-ref-main" d="M35 29Q50 22 65 29L71 61L61 64L59 96H41L39 64L29 61Z"/>'
        };
        return markup[type] || markup.tv;
      }

      update() {
        const dimensions = this.parseDimensions(this.currentVariant());
        if (!dimensions || !this.stage) {
          if (this.sizeReadout) this.sizeReadout.textContent = this.dataset.unavailable || '';
          return;
        }
        const type = this.referenceSelect?.value || 'tv';
        const reference = this.references()[type];
        this.stage.dataset.layout = reference.layout;
        this.referenceSvg.innerHTML = this.referenceMarkup(type);
        const stageWidth = Math.max(this.stage.clientWidth, 320);
        const stageHeight = Math.max(this.stage.clientHeight, 330);
        let scale;
        if (reference.layout === 'above') {
          scale = Math.min((stageWidth - 70) / Math.max(dimensions.width, reference.width), (stageHeight - 105) / (dimensions.height + reference.height + 15));
        } else {
          scale = Math.min((stageWidth - 80) / (dimensions.width + reference.width + 18), (stageHeight - 90) / Math.max(dimensions.height, reference.height));
        }
        scale = Math.max(scale, 1);
        this.art.style.width = `${Math.round(dimensions.width * scale)}px`;
        this.art.style.height = `${Math.round(dimensions.height * scale)}px`;
        this.referenceObject.style.width = `${Math.round(reference.width * scale)}px`;
        this.referenceObject.style.height = `${Math.round(reference.height * scale)}px`;
        const width = this.unit === 'cm' ? dimensions.width * 2.54 : dimensions.width;
        const height = this.unit === 'cm' ? dimensions.height * 2.54 : dimensions.height;
        const suffix = this.unit === 'cm' ? this.dataset.unitCm : this.dataset.unitIn;
        this.sizeReadout.textContent = `${this.dataset.sizePrefix || ''} ${Math.round(width * 10) / 10} × ${Math.round(height * 10) / 10} ${suffix}`;
        this.referenceReadout.textContent = reference.label;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["three-piece-scale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('three-piece-scale')) {
    customElements.define('three-piece-scale', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.mwc-triptych-dialog');
        this.trigger = this.querySelector('.mwc-triptych-trigger');
        this.referenceSelect = this.querySelector('.mwc-triptych-reference');
        this.stage = this.querySelector('.mwc-triptych-stage');
        this.art = this.querySelector('.mwc-triptych-art');
        this.referenceObject = this.querySelector('.mwc-triptych-reference-object');
        this.referenceSvg = this.querySelector('.mwc-triptych-reference-svg');
        this.sizeReadout = this.querySelector('.mwc-triptych-size');
        this.referenceReadout = this.querySelector('.mwc-triptych-reference-label');
        this.variants = JSON.parse(this.querySelector('.mwc-triptych-variants')?.textContent || '[]');
        this.unit = 'in';
        this.referenceSelect.value = this.dataset.defaultReference || 'tv';
        this.trigger?.addEventListener('click', () => {
          this.dialog?.showModal();
          requestAnimationFrame(() => this.update());
        });
        this.referenceSelect?.addEventListener('change', () => this.update());
        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.addEventListener('click', () => {
            this.unit = button.dataset.unit;
            this.querySelectorAll('[data-unit]').forEach((item) => {
              const active = item === button;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', String(active));
            });
            this.update();
          });
        });
        this.productArea = this.closest('.shopify-section') || document;
        this.productArea.addEventListener('change', this.handleVariantChange = () => setTimeout(() => this.update(), 40));
        this.productArea.addEventListener('variant:update', this.handleVariantUpdate = () => this.update());
        window.addEventListener('resize', this.handleResize = () => {
          if (this.dialog?.open) this.update();
        });
      }

      disconnectedCallback() {
        this.productArea?.removeEventListener('change', this.handleVariantChange);
        this.productArea?.removeEventListener('variant:update', this.handleVariantUpdate);
        window.removeEventListener('resize', this.handleResize);
      }

      currentVariant() {
        const inputs = this.productArea?.querySelectorAll('form[action*="/cart/add"] [name="id"]') || [];
        for (const input of inputs) {
          const match = this.variants.find((variant) => String(variant.id) === String(input.value));
          if (match) return match;
        }
        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        return this.variants.find((variant) => String(variant.id) === String(urlVariant)) || this.variants.find((variant) => String(variant.id) === String(this.dataset.initialVariant)) || this.variants[0];
      }

      parseDimensions(variant) {
        if (!variant) return null;
        const text = [...(variant.options || []), variant.title || ''].join(' | ').replace(/[\u200e\u200f\u2066-\u2069]/g, '').replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).replace(/سم/g, 'cm').replace(/بوصة/g, 'in');
        const inchMatches = [...text.matchAll(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ches)?\b)/gi)];
        if (inchMatches.length) {
          const match = inchMatches[inchMatches.length - 1];
          return { width: Number(match[1]), height: Number(match[2]) };
        }
        const cmMatch = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\b/i);
        if (cmMatch) return { width: Number(cmMatch[1]) / 2.54, height: Number(cmMatch[2]) / 2.54 };
        return null;
      }

      references() {
        return {
          tv: { width: 61, height: 34.3, layout: 'side', label: this.referenceSelect.options[0].text },
          sofa: { width: 84, height: 34, layout: 'above', label: this.referenceSelect.options[1].text },
          queen: { width: 60, height: 48, layout: 'above', label: this.referenceSelect.options[2].text },
          king: { width: 76, height: 48, layout: 'above', label: this.referenceSelect.options[3].text },
          desk: { width: 60, height: 30, layout: 'above', label: this.referenceSelect.options[4].text },
          person: { width: 22, height: 70, layout: 'side', label: this.referenceSelect.options[5].text }
        };
      }

      referenceMarkup(type) {
        const markup = {
          tv: '<rect class="mwc-ref-main" x="4" y="4" width="92" height="82" rx="2"/><path class="mwc-ref-detail" d="M37 92H63M50 86V92"/>',
          sofa: '<path class="mwc-ref-main" d="M7 45Q7 34 18 34H82Q93 34 93 45V84H7Z"/><path class="mwc-ref-detail" d="M7 62H93M20 34V62M80 34V62M14 84V96M86 84V96"/>',
          queen: '<path class="mwc-ref-main" d="M5 25H95V88H5Z"/><path class="mwc-ref-detail" d="M5 55H95M12 88V97M88 88V97"/>',
          king: '<path class="mwc-ref-main" d="M5 25H95V88H5Z"/><path class="mwc-ref-detail" d="M5 55H95M12 88V97M88 88V97"/>',
          desk: '<path class="mwc-ref-main" d="M5 28H95V48H5Z"/><path class="mwc-ref-detail" d="M14 48V96M86 48V96M31 62H69"/>',
          person: '<circle class="mwc-ref-main" cx="50" cy="14" r="11"/><path class="mwc-ref-main" d="M35 29Q50 22 65 29L71 61L61 64L59 96H41L39 64L29 61Z"/>'
        };
        return markup[type] || markup.tv;
      }

      update() {
        const dimensions = this.parseDimensions(this.currentVariant());
        if (!dimensions || !this.stage) {
          if (this.sizeReadout) this.sizeReadout.textContent = this.dataset.unavailable || '';
          return;
        }
        const panelWidth = dimensions.width;
        dimensions.width = panelWidth * 3 + 4;
        const type = this.referenceSelect?.value || 'tv';
        const reference = this.references()[type];
        this.stage.dataset.layout = reference.layout;
        this.referenceSvg.innerHTML = this.referenceMarkup(type);
        const stageWidth = this.stage.clientWidth || 280;
        const stageHeight = Math.max(this.stage.clientHeight, 330);
        let scale;
        if (reference.layout === 'above') {
          scale = Math.min((stageWidth - 70) / Math.max(dimensions.width, reference.width), (stageHeight - 105) / (dimensions.height + reference.height + 15));
        } else {
          scale = Math.min((stageWidth - 80) / (dimensions.width + reference.width + 18), (stageHeight - 90) / Math.max(dimensions.height, reference.height));
        }
        scale = Math.max(scale, 0.1);
        this.art.style.gap = `${2 * scale}px`;
        this.art.style.width = `${Math.round(dimensions.width * scale)}px`;
        this.art.style.height = `${Math.round(dimensions.height * scale)}px`;
        this.referenceObject.style.width = `${Math.round(reference.width * scale)}px`;
        this.referenceObject.style.height = `${Math.round(reference.height * scale)}px`;
        const width = this.unit === 'cm' ? dimensions.width * 2.54 : dimensions.width;
        const height = this.unit === 'cm' ? dimensions.height * 2.54 : dimensions.height;
        const suffix = this.unit === 'cm' ? this.dataset.unitCm : this.dataset.unitIn;
        this.sizeReadout.textContent = `${this.dataset.sizePrefix || ''} ${Math.round((this.unit === 'cm' ? panelWidth * 2.54 : panelWidth) * 10) / 10} × ${Math.round(height * 10) / 10} ${suffix} · ${this.dataset.totalLabel} ${Math.round(width * 10) / 10} ${suffix}`;
        this.referenceReadout.textContent = reference.label;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
